import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}api/seagull`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const seagullApi = {
  postSyncProduct: (request) => {
    const { body, config } = request
    return instance().post(`/sync-products`, body, config)
  }
}
export default seagullApi



// WEBPACK FOOTER //
// ./src/api/seagull.js